﻿import React, { useEffect, useMemo, useState } from 'react';
import { Input, Table, Checkbox } from 'antd';

import { Pergunta } from '../../../api/minuta/Pergunta';
import { getAllRespostaByPerguntaId, putAtualizarDescricaoResposta, Resposta } from '../../../api/minuta/Resposta';
import { isObjNotEmpty } from '@app/helpers/objHelper';

interface TabelaRespostasItemClausulaProps {
  perguntaResult: Pergunta;
  onSelectResult: (respostas: Resposta[]) => void;
  respostasChecked?: Resposta[];
  ocultaEdicao?: boolean;
}

const TabelaRespostasItemClausula = ({
  perguntaResult,
  onSelectResult,
  respostasChecked,
  ocultaEdicao,
}: TabelaRespostasItemClausulaProps) => {
  const [pergunta, setPergunta] = useState<Pergunta>(perguntaResult);
  const [respostasChecadas, setRespostasChecadas] = useState<Resposta[]>([]);

  useEffect(() => {
    onSelectResult(respostasChecadas);
  }, [respostasChecadas]);

  useMemo(() => {
    //marcando as respostas
    if (respostasChecked) {
      respostasChecked.forEach(rc => {
        rc.isChecked = true;
      });
      setRespostasChecadas(respostasChecked);
      perguntaResult.respostas.forEach(resposta => {
        if (respostasChecked.find(r => r.id === resposta.id)) {
          resposta.isChecked = true;
        }
      });
    }
    setPergunta({ ...perguntaResult } as Pergunta);
  }, [perguntaResult, respostasChecked]);

  const definirItemEditavel = (respostaId: string) => {
    if (pergunta && pergunta.respostas.length > 0) {
      const respostaResult = pergunta.respostas.map(respota => {
        if (respota.id === respostaId) {
          respota.editavel = true;
        } else {
          respota.editavel = false;
        }
        return respota;
      });
      setPergunta({ ...pergunta, respostas: respostaResult } as Pergunta);
    }
  };

  const updateResposta = (record: Resposta, desricao: string) => {
    if (pergunta) {
      const novaResposta = {
        perguntaId: pergunta.id,
        id: record.id,
        descricao: desricao,
      } as Resposta;

      putAtualizarDescricaoResposta(novaResposta).then(data => {
        if (data) {
          getAllRespostaByPerguntaId(novaResposta.perguntaId).then(result => {
            setPergunta({ ...pergunta, respostas: result } as Pergunta);
          });
        }
      });
    }
  };

  const onChangeCheckbox = (checked: boolean, resposta: Resposta | undefined, record: Resposta) => {
    let tempResposta = { ...resposta } as Resposta;

    if (isObjNotEmpty(tempResposta)) {
      tempResposta.isChecked = checked;
    } else {
      tempResposta = {
        id: record.id,
        descricao: record.descricao,
        isChecked: checked,
        editavel: false,
        ordem: record.ordem,
        perguntaId: record.perguntaId,
      } as Resposta;
    }

    let respostasParaSalvar: Resposta[] = [...respostasChecadas, tempResposta];

    if (resposta && checked == false) {
      const respostaFiltrada = respostasChecadas.filter(d => d.id !== resposta.id);
      respostasParaSalvar = respostaFiltrada;
    }

    setRespostasChecadas(respostasParaSalvar);

    //atualizando as respostas na pergunta
    pergunta.respostas.forEach(f => {
      if (f.id === record.id) {
        f.isChecked = checked;
      }
    });
    setPergunta({ ...pergunta } as Pergunta);
  };

  const collunsResposta = [
    {
      title: 'Ordem',
      dataIndex: 'ordem',
      width: '5%',
    },
    {
      title: 'Resposta',
      dataIndex: 'descricao',
      width: '90%',
      render: (index, record, rowKey) => {
        if (ocultaEdicao === true) {
          return <div> {record.descricao} </div>;
        }

        if (record.editavel != true) {
          return (
            <div
              onClick={() => {
                definirItemEditavel(record.id);
              }}>
              {record.descricao}
            </div>
          );
        }
        return (
          <>
            <Input
              name={`editDescicao${record.id}`}
              onPressEnter={e => {
                if (e) {
                  const descricaoAlterada = e.target.value;
                  updateResposta(record, descricaoAlterada);
                }
              }}
              defaultValue={record.descricao}
              ref={node => {}}
              onBlur={() => {}}
            />
          </>
        );
      },
    },
    {
      title: 'Selecionar',
      isDummyField: true,
      width: '5%',
      render: (index, record, rowkey) => {
        const respTemp = pergunta.respostas.find(resposta => resposta.id === record.id);

        return (
          <Checkbox
            checked={respTemp ? respTemp.isChecked : false}
            disabled={false}
            onChange={e => onChangeCheckbox(e.target.checked, respTemp, record)}
          />
        );
      },
    },
  ];

  return <Table dataSource={pergunta.respostas} rowKey={'id'} columns={collunsResposta} pagination={false} />;
};

export default TabelaRespostasItemClausula;
